document.addEventListener('DOMContentLoaded', function() {
  let flag = false;
  
  let hero = document.querySelector('.hero');



  if (hero) {
        let heroSliderAutoplay = hero.querySelector(".swiper-container").dataset.time;
            varAutoplay = {
            delay: heroSliderAutoplay*1000,
            disableOnInteraction: false,
        };
        let heroSliderPagination = $(".hero-slider__pagination");
      let slNav = hero.querySelector('.sl-nav');
      let slPag = hero.querySelector('.swiper-pagination');
      let slider = new Swiper('.hero .swiper-container', {
          slidesPerView: 'auto',
          spaceBetween: 9,
          pagination: {
              el: '.hero-slider__pagination',
              renderBullet: function (index, className) {
                return '<div class="' + className + '">' +
                    '<div class="pag-dot-progress"></div>' +
                    '</div>';
              },
              clickable: true,
          },
          on: {
              init: function () {
                  setTimeout(function() {
                      heroSliderPagination.find(".swiper-pagination-bullet-active").find(".pag-dot-progress").addClass("pag-anim-play").css({
                          "transition-duration": heroSliderAutoplay+"s",
                      });
                      flag = true;
                  },0);
              },
              paginationUpdate: function (i) {
                  if ( flag ) {
                      heroSliderPagination.find(".pag-anim-play").removeClass("pag-anim-play").removeAttr("style");
                      heroSliderPagination.find(".swiper-pagination-bullet-active .pag-dot-progress").addClass("pag-anim-play").css({
                          "transition-duration": heroSliderAutoplay+"s",
                      });
                  }
              },
          },
          autoplay: varAutoplay,
          navigation: {
              prevEl: slNav.querySelector('.sl-nav__btn--prev'),
              nextEl: slNav.querySelector('.sl-nav__btn--next'),
          },

      });
  }

});